// *** Create Post Component ****
import React, { useEffect, useState, useRef } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { Modal } from "react-bootstrap";
import thumb from "../../assets/img/post/add-pop-thumb.svg"
import {
  getUserCommunities,
  getCommunityTopics,
  savePost, editPost,checkTopicExist
} from "../../services/apiPosts";
import "../../assets/css/style.css";
import "../../assets/css/text-limit.css";
import { useNavigate, useLocation } from 'react-router-dom';
import search from "../../assets/img/sreach---icon.svg";
import Validation from "../../commonComponents/Validation";
import {checkCharacterLimit}  from "../../utils/textLimiter";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
const CreatePost = (props) => {
  const MAX_POST_LENGTH = 4000;
const [characterLimit, setCharacterLimit] = useState({
  isOverLimit: false,
  remaining: MAX_POST_LENGTH,
  limitedText: ''
});
  const MAX_TOPIC_LENGTH = 20;
const [characterTopicLimit, setCharacterTopicLimit] = useState({
  isOverLimit: false,
  remaining: MAX_TOPIC_LENGTH,
  limitedTopicText: ''
});
const MAX_SUBJECT_LENGTH = 40;
const [characterSubjectLimit, setCharacterSubjectLimit] = useState({
  isOverLimit: false,
  remaining: MAX_SUBJECT_LENGTH,
  limitedSubjectText: ''
});
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [selectedCommunity, setSelectedCommunity] = useState("");
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [Communities, setCommunities] = useState([]);
  const location = useLocation();
  const [Topics, setTopics] = useState([]);
  const [topicName, setTopicName] = useState('');
  const [topicSelected, setTopicSelected] = useState(false);
  const [topicid, setTopicId] = useState('');
  const[ExistTopic,setExistTopic] = useState(false);
  const [SearchStatus, setSearchStatus] = useState(false);
  const [isNewTopic, setIsNewTopic] = useState(false);
  const[isSucess,SetSucess]=useState(false);
  const[isCreateNew,SetIsCreateNew]=useState(false);
  const[ResponseMessage,SetResponseMessage]=useState("");
  const[CommunityName,SetCommunityName]=useState([]);
  
const topicInputRef = useRef(null);

  const fetchAllCommunities = async (payload) => {
    let listCommunities = await getUserCommunities(payload);
    setCommunities(listCommunities?.communities || []);
  };
  const closePopup = () => {
    props.closePop();
    setErrors(false);
    setErrors({});
    setFormData({
      communityid: "",
      topicid: "",
      subject: "",
      post:""
    });
    
    setTopicName('');
    setTopicSelected(false);
    setTopicId('');
    setSearchStatus(false);
    setIsNewTopic(false);

  };
  const [formData, setFormData] = useState({
    communityid: "",
    topicid: "",
    subject: "",
    post:"",
  });
  // Topic selection based on Keywords onsearch
  useEffect(() => {
    const fetchTopics = async () => {
      setSearchStatus(false);
      setIsNewTopic(false);
      if (!selectedCommunity) {
      setTopics([]);
      return;
    }
      
        let topicpayload = { communityid: selectedCommunity, searchkey: topicName };
        let listTopics = await getCommunityTopics(topicpayload);
        const topics = listTopics?.topics || [];
        if (topics.length == 0 ) {
          setSearchStatus(true);
        }
        setTopics(topics);
      
    };
    fetchTopics();
  }, [topicName, selectedCommunity]);


  // Fetch All Communities
  useEffect(() => {
    if (props.openPop) {
      let payload = { userid: userData._id };
      fetchAllCommunities(payload);
      // Set Choosed Community id in selctbox
      const storedCommunityId = localStorage.getItem("communityId");
      setSelectedCommunity(storedCommunityId);
      if (storedCommunityId) {
        setFormData((prevData) => ({
          ...prevData,
          communityid: storedCommunityId,
        }));

        // Fetch Topics
        let topicpayload = { communityid: storedCommunityId };
        getCommunityTopics(topicpayload).then((response) => {
          const topics = response?.topics || [];
          setTopics(topics);

        });


      } else {
        setFormData((prevData) => ({
          ...prevData,
          communityid: "",
          topicid: "",
          subject: "",
        }));
        setTopics([]);

      }

    }

  }, [props.openPop]);


  useEffect(() => {
    if (props.EditStatus && props.EditFeed) {
      setFormData({
        subject: props.EditFeed.postTitle,
        communityid: props.EditFeed.communityId || "",
        topicid: props.EditFeed.topicId || "",
        post: props.EditFeed.postDescription || "",
      });
      setErrors({});
    } else {
      setFormData({
        communityid: "",
        topicid: "",
        subject: "",
        post:"",
      });

      setErrors({});
     
    }
  }, [props.EditStatus, props.EditFeed]);

  const isExistTopic =async function(name,val){
    
      let checkExit = await checkTopicExist({'communityid':selectedCommunity,topic:val});
      
      if(checkExit.status === true){
         setExistTopic(true);
         formData.topicname="";
         setSearchStatus(false)
      }
      else
       setExistTopic(false);
 
  }

  const handleChange = async (event) => {
     setExistTopic(false);
    const { name, value } = event.target;
     if(name === "post" || name === "subject" || name === "topicname"){
      let limitInfo, limitSubjectInfo,limitTopicInfo;
       if(name === "post"){
        limitInfo = checkCharacterLimit(value, MAX_POST_LENGTH);
        setCharacterLimit(limitInfo);
           if (!limitInfo.isOverLimit || value.length < formData.post.length) {
        setFormData(prevData => ({
          ...prevData,
          [name]: limitInfo.limitedText,
        }));
      }
       }
       if(name === "subject"){
        limitSubjectInfo = checkCharacterLimit(value, MAX_SUBJECT_LENGTH);
        setCharacterSubjectLimit(limitSubjectInfo);
        setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
       }

        if(name === "topicname"){
        limitTopicInfo = checkCharacterLimit(value, MAX_TOPIC_LENGTH);
        setCharacterTopicLimit(limitTopicInfo);
        setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      isExistTopic(name,value)
      //setTopicName(event.target.value)
      if (value.trim() === "") {
    setSearchStatus(false);
    setTopicName(event.target.value)
  }
       }
   
     }
     else {
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  }

    
    const selectedCommunityDetail = Communities.find(
      (community) => community.communityId && community.communityId._id === value
      );
    
    if (selectedCommunityDetail) {
      localStorage.setItem("communityData", JSON.stringify(selectedCommunityDetail?.communityId));
      SetCommunityName(selectedCommunityDetail?.communityId)
    }
    localStorage.setItem('communityId', formData.communityid);  
   if (name == "communityid" && value) {
      setSelectedCommunity(value);

      setSearchStatus(false);
      formData.topicname="";
      setTopicName('');
      SetIsCreateNew(false)
      let topicpaylod = { communityid: value };
      let listTopics = await getCommunityTopics(topicpaylod);
      const topics = listTopics?.topics || [];
      setTopics(topics);
      // Clear topic-related errors when community changes
      setErrors((prevErrors) => ({
        ...prevErrors,
        topicid: '',
        topicname: '',
      }));

    
    

    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '', // Clear only the error for the current field
    }));
  };
useEffect(() => {
  if (topicInputRef.current) {
    topicInputRef.current.focus();
  }
}, [SearchStatus, formData.topicname]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.communityid) newErrors.communityid = true;
    if (!formData.topicid && isNewTopic === false) newErrors.topicid = true;
   const subjectValue = formData.subject?.trim();
  if (!subjectValue) {
    newErrors.subject = true;
  } else if (subjectValue.length > MAX_SUBJECT_LENGTH) {
    newErrors.subjectLength = true;
  }
    if (!formData.topicname && isNewTopic === true) newErrors.topicname = true;
    if (!formData.post) newErrors.post = true;
    if (characterLimit.isOverLimit) newErrors.postLength = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSavePost = async (event) => {

     if (!props.EditStatus && isNewTopic === false)
      formData.topicid = topicid;
      event.preventDefault();
    if (!validateForm()) return;
    formData.userid = userData._id;
    localStorage.setItem('communityId', formData.communityid);
    let response;
    try {
      if (props.EditStatus === true) {
        formData.postid = props.EditFeed._id;
        response = await editPost(formData);
        if(response.status === false){
           SetSucess(true);
         SetResponseMessage(response.message);
        }
      }
      else
        
        response = await savePost(formData);
      if (response.status === true) {
        props.closePop();
        if (location.pathname.startsWith("/feed/") ) {
           window.location.reload();
        
        }
        else if ((location.pathname === "/profile")|| (location.pathname === "/organization")) {
          props.fetchAllFeeds({userid:userData._id,offset: 0,limit: 10});
        }
        if (location.pathname === "/post") {
           window.location.reload();
        
        }

        else
          navigate(`/feed/${CommunityName?.communityName.trim().replace(/\s+/g, '-').toLowerCase()}`);
      }
      else{
         SetSucess(true);
         SetResponseMessage(response.message);
      }
    } catch (error) {


      console.log(error);
    }

  };

  return (
    <div>
      <Modal dialogClassName="custom-modal modal-dialog-centered" show={props.openPop} onHide={closePopup}>
        <Modal.Header closeButton>
          <div className="popupheader">
            <div className="mod-bor-icon" >
              <img src={thumb} className="mod-icon"></img>
            </div>
            <div className="header">
              <h4 className="modal-tittle">{props.EditStatus ? "Edit a Post" : "Create a Post"}</h4>

            </div>
          </div>
        </Modal.Header>

        <Modal.Body>

          {!props.EditStatus && (

            <div className="row">
              <div className="col-lg-12">

                <div className="form-group custom-form-group">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={handleChange}
                    name="communityid"
                    value={formData.communityid}
                  >
                    <option value="" className="font">
                      Select Community
                    </option>

                    {Communities.map((community) => {
                      if (community && community.communityId) {
                        return (
                          <option
                            key={community.communityId._id}
                            value={community.communityId._id}
                          >
                            {community?.communityId?.communityName}
                          </option>
                        );
                      }
                      return null; // Return null if data.communityName doesn't exist
                    })}
                  </select>
                </div>
                {errors.communityid && (
                  <Validation message={'Please Choose Community'} />
                )}
              </div>


              {!SearchStatus &&  <div className="col-lg-12">
                <div className="position-relative form-group custom-form-group searchtopic-wrapper">
                  <input
                    type="search"
                    ref={topicInputRef}
                    className="form-control search-plg" // ps-5 adds left padding
                    placeholder="Tag a Topic"
                    id="exampleFormControlInput1"
                    autoComplete="off"
                    value={topicName}
                    onChange={(e) => {
                      e.preventDefault();
                      setTopicName(e.target.value);
                      setTopicSelected(true);
                      setFormData((prevData) => ({
        ...prevData,
        ["topicname"]: e.target.value,
      }));
                    }}
                    onFocus={async () => {
                      // Fetch topics when user clicks the search field
                      if (selectedCommunity) {
                        let topicpayload = { communityid: selectedCommunity };
                        let listTopics = await getCommunityTopics(topicpayload);
                        setTopics(listTopics?.topics || []);
                        setTopicSelected(true); // Show dropdown immediately
                      }
                    }}
                  />
                  { !SearchStatus && <img src={search} alt="Search" className="search-icon-inside-field" />}
                  {/* Optional link and dropdown logic remains same */}
                  {SearchStatus && (
                    <div className="no-community">
                      <Link onClick={() => {
                        setIsNewTopic(true);
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          topicid: '', // Clear topicid error
                          topicname: '' // Clear topicname error
                        }));
                      }} className="text-primary small">
                        Create New
                      </Link>
                    </div>
                  )}

                  {Topics.length > 0 && topicSelected && (
                    <ul className="list-pops nw-search-sugg list-group position-absolute  mt-1 z-index-dropdown">
                      {Topics.map((topics, index) =>
                        topics ? (
                          <li key={index} className="list-group-item d-flex align-items-center">
                            <input
                              type="radio"
                              name="topicid"
                              id={`option-${index}`}
                              value={topics._id}
                              checked={topicName === topics.topicTitle}
                              onChange={(e) => {
                                e.preventDefault();
                                setTopicName(topics.topicTitle);
                                setTopicId(topics._id);
                                setTopicSelected(false);
                                setErrors((prevErrors) => ({
                                          ...prevErrors,
                                          topicid: '', // Clear the topicid error when a topic is selected
                                        }));
                                 }}
                              className="form-check-input me-2 s-pick"
                            />
                            <label htmlFor={`option-${index}`} className="form-check-label w-100 s-pic-text">
                              {topics.topicTitle}
                            </label>
                          </li>
                        ) : null
                      )}
                    </ul>
                  )}

                  {errors.topicid && (
                    <div className="mt-2 text-danger small">
                      <Validation message={'Please Choose Topic'} />
                    </div>
                  )}
                </div>
              </div>}




            </div>
          )}
{formData.topicname !== "" && SearchStatus && <div className="col-lg-12">
              <div className=" position-relative form-group custom-form-group searchtopic-wrapper">
                <input
                  type="text"
                  ref={topicInputRef}
                  className="form-control search"
                  placeholder="Tag a Topic"
                  name="topicname"
                  value={formData.topicname}
                  onChange={handleChange}
                 // onBlur ={isExistTopic}
                  maxLength={MAX_TOPIC_LENGTH}
                />
                {SearchStatus && (
                    <div className="no-community">
                      <Link onClick={() => {
                        isExistTopic("topicname",formData.topicname)
                         setIsNewTopic(true);
                         SetIsCreateNew(true)
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          topicid: '', // Clear topicid error
                          topicname: '' // Clear topicname error
                        }));
                      }} className="text-primary small">
                        {isCreateNew ? "" : "Create New"}
                      </Link>
                    </div>
                  )}
                  
              </div>
               {ExistTopic &&  <Validation message={'Topic Exist'} />}
              <div className={`character-counter ${characterTopicLimit.isOverLimit ? 'text-danger' : 'text-muted'}`}>
          {characterTopicLimit.remaining} characters remaining
      {characterTopicLimit.remaining <= 0 && (
        <span className="limit-warning"> (Maximum limit reached)</span>
      )}</div>
              {ExistTopic &&  <Validation message={'Topic Exist'} />}
              {errors.topicname && (
                <Validation message={'Please Enter Your Topic'} />
              )}
            </div>}


          <div className="col-lg-12">
            <div className="form-group custom-form-group">
              <input
                type="text"
                className="form-control search"
                placeholder="Enter Subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                maxLength={MAX_SUBJECT_LENGTH}
              />
               <div className={`character-counter ${characterSubjectLimit.isOverLimit ? 'text-danger' : 'text-muted'}`}>
          {characterSubjectLimit.remaining} characters remaining</div>
      {characterSubjectLimit.remaining <= 0 && (
        <span className="limit-warning"> (Maximum limit reached)</span>
      )}
            </div>
            {errors.subject && (
              <Validation message={'Please Enter Subject'} />
            )}
          </div>
          <div className="col-sm-12">
            <div className="form-group custom-form-group">
            <textarea 
            name="post" 
            id="post" 
            onChange={handleChange} 
            className="post-textarea form-control"
            value={formData.post}
            maxLength={MAX_POST_LENGTH}
          />
          <div className={`character-counter ${characterLimit.isOverLimit ? 'text-danger' : 'text-muted'}`}>
          {characterLimit.remaining} characters remaining</div>
      {characterLimit.remaining <= 0 && (
        <span className="limit-warning"> (Maximum limit reached)</span>
      )}
            </div>
          </div>
          {errors.post && (
            <Validation message={'Please Enter Post Content'} />
          )}


          <div className="d-flex justify-content-between">

          </div>

        </Modal.Body>
        <Modal.Footer className="full-w" >
          <button
            type="button"
            className="cancel-btn"
            onClick={() => {
              closePopup();
            }}
          >
            Cancel
          </button>

          <button className="next-btn" onClick={(e) => handleSavePost(e)}>
            {" "} {props.EditStatus ? "Update Post" : "Post Now"}{" "}
          </button>
        </Modal.Footer>
      </Modal>
       {isSucess && (<ResponsePopup 
                      isSucess={isSucess} 
                      CancelPopup={() => { 
                       SetSucess(false);
                      }} 
                      message={ResponseMessage}
                    />)}
    </div>
  );
};
export default CreatePost;